module.exports = {"id":"189945","name":"Yoric Ravet","rating":"76","photo":"./data/images/photos/3/189945.png","club":{"name":"SC Fribourg","logo":"./data/images/clubs/SCFribourg.png"},"positions":["MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YoricRavet0.json
// module id = 4425
// module chunks = 0